import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import jwtDecode from 'jwt-decode';
import PageHeader from '../page-header';
const queryString = require('query-string');

export type AppProps = RouteComponentProps<any> & InjectedTranslateProps;

export interface AppState {
  error?: String;
  success: boolean;
}

class IdentityVerificationResult extends React.Component<AppProps, AppState> {
  constructor(props) {
    super(props);

    this.state = {
      success: true,
    };
  }

  componentDidMount(): void {
    const search = queryString.parse(this.props.location.search);

    const identityToken = search.identityToken ? search.identityToken : '';
    const message = {
      identityToken,
    };

    try {
      const targetOrigin = jwtDecode(identityToken).aud;

      if (this._isIframe()) {
        window.parent.postMessage(message, targetOrigin);
      } else {
        window.opener.postMessage(message, targetOrigin);
      }
    } catch (e) {
      /* eslint-disable no-console */
      console.warn(e);
      this.setState({ success: false });
    }
  }

  _isIframe() {
    try {
      const bool = window.self !== window.top;

      return bool;
    } catch (e) {
      return true;
    }
  }

  render() {
    if (this.state.success) {
      return null;
    }

    return (
      <div className='container'>
        <PageHeader
          i18nHeader='self-auth-title'
          i18nSubHeader='error-message-invalid-usage'
        />
      </div>
    );
  }
}

export default compose(
  withRouter,
  translate(),
  connect()
)(IdentityVerificationResult);



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/components/identity-verification-result/index.tsx